import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import generatePDF from 'react-to-pdf';
import { useReactToPrint } from "react-to-print";
import { useDownloadExcel } from 'react-export-table-to-excel';
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
export default function ClientsReport() {
    var date = new Date();
    const targetRef = useRef();
    const printReady = useReactToPrint({
        content: () => targetRef.current,
      });
      const { onDownload } = useDownloadExcel({
        currentTableRef: targetRef.current,
        filename: 'ClientReport',
        sheet: 'Clients'
    })
    const [lists, setLists] = useState([]);
    const [clients, setClients] = useState([]);
    const [fromDate, setFromDate] = useState(new Date(date.getTime() - (7 * 24 * 60 * 60 * 1000)))
    const [toDate, setToDate] = useState(new Date())
    const [clientId, setClientId] = useState("00000000-0000-0000-0000-000000000000");
    const [status, setStatus] = useState(true);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.REPORTCLIENTS + "?fromDate=" + moment(fromDate).format('YYYY-MM-DD') + "&toDate=" + moment(toDate).format('YYYY-MM-DD') + "&clientId=" + clientId + "&Status=" + status, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLists(response.data.data);
                }
            });
    };
    const GetClients = () => {
        axios.get(config.APIACTIVATEURL + config.GETALLCLIENTS, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setClients(response.data.data);
                }
            });
    };
    const handleSearch = (e) => {
        e.preventDefault();
        GetData();
    }
    const resetForm = (e) => {
        e.preventDefault();
        setFromDate(new Date(date.getTime() - (7 * 24 * 60 * 60 * 1000)));
        setToDate(new Date());
        setClientId("00000000-0000-0000-0000-000000000000");
    }
    const handleFromDate = (date) => {
        if (date !== null) {
            setFromDate(date)
            addDays(date)
        }
    }
    const handleToDate = (date) => {
        if (date !== null) {
            setToDate(date)
            addDays(date)
        }
    }
    const addDays = (fromDate) => {
        if (fromDate === undefined) {
            fromDate = new Date();
        }
        const newDate = new Date(fromDate.getTime());
        setToDate(newDate.setDate(fromDate.getDate()));
    }
    const handleClient = (e) => {
        setClientId(e.target.value);
        GetData();
    }
    useEffect(() => {
        GetData();
        GetClients();
    }, [])
    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div class="card card-body py-3">
                    <div className="row mb-3 mt-1">
                            <div style={{ width: "20%" }}>
                                <label htmlFor="from_date" className="form-label">From Date</label>
                                <div className="position-relative">
                                    <ReactDatePicker autoComplete="false" className="form-control" wrapperClassName="datePicker" name="fromDate" selected={fromDate} onChange={(date) => handleFromDate(date)} dateFormat="dd MMM yyyy" />
                                    <span className="icon-inside"><i className="ri-calendar-line" /></span>
                                </div>
                            </div>
                            <div style={{ width: "20%" }}>
                                <label htmlFor="clients" className="form-label">ToDate</label>
                                <div className="position-relative">
                                    <ReactDatePicker autoComplete="false" className="form-control" wrapperClassName="datePicker" name="toDate" selected={toDate} onChange={(date) => handleToDate(date)} dateFormat="dd MMM yyyy" />
                                    <span className="icon-inside"><i className="ri-calendar-line" /></span>
                                </div>
                            </div>
                            <div style={{ width: "15%" }}>
                                <label htmlFor="clients" className="form-label">Clients</label>
                                <select className="form-select" onChange={(e) => setClientId(e.target.value)} value={clientId} name="clientId">
                                    <option value={"00000000-0000-0000-0000-000000000000"}>All Clients</option>
                                    {clients.length > 0 && clients.map(c =>
                                        <option value={c.clientId}>{c.clientName}</option>
                                    )}
                                </select>
                            </div>
                            <div style={{ width: "15%" }}>
                                <label htmlFor="status" className="form-label">Status</label>
                                <select className="form-select" onChange={(e) => setStatus(e.target.value)} value={status} name="status">
                                    <option value={true}>Active</option>
                                    <option value={false}>In-Active</option>
                                </select>
                            </div>
                            <div style={{ width: "30%" }}>
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    <button type="button" className="btn btn-success" onClick={handleSearch}>Search</button>
                                    <button type="button" className="btn btn-danger" onClick={resetForm}>Clear</button>
                                    <div className="btn-group">
                                        <button className="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                            Download
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <li>
                                                <Link onClick={() => generatePDF(targetRef, { filename: 'ClientsReport.pdf' })} className="dropdown-item">PDF</Link>
                                            </li>                                            
                                            <li>
                                                <Link onClick={onDownload} className="dropdown-item">Excel</Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" onClick={printReady}>Print</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                            </div>
                    <div className="card w-100 position-relative" ref={targetRef}>
                        <div className="row">
                            <div className="col-lg-12">
                            <div className="px-4 py-3 border-bottom">
                                    <h4 className="mb-2 card-title">Clients Report</h4>
                                </div>
                                <div class="card-body p-4">
                                <div className="table-responsive table-card">
                                    <table className="table align-middle" id="customerTable">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Id</th>
                                                <th>Client Name</th>
                                                <th>Plan Name</th>
                                                <th>Joined on</th>
                                                <th>Status</th>
                                                <th>Users</th>
                                                <th>Funders</th>
                                                <th>Credits</th>
                                            </tr>
                                        </thead>
                                        <tbody className="list form-check-all">
                                            {lists.length > 0 && lists.map((v, index) =>
                                                <tr key={v.clientId}>
                                                    <td>{index + 1}</td>
                                                    <td>{v.clientName}</td>
                                                    <td>{v.subscriptionName}</td>
                                                    <td>{moment(v.createdDate).format('DD MMM YYYY')}</td>
                                                    <td>{v.isActive === true ? <span className="badge bg-success">ACTIVE</span> : <span className="badge bg-warning">IN-ACTIVE</span>}</td>
                                                    <td>{v.users}</td>
                                                    <td>{v.funders}</td>
                                                    <td>{v.credits}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}